<div *ngIf="quotationDetails">
    <div class="p-dynamic-dialog-body quotation-details">
        <div>
            <span class="quotation-version">{{quotationDetails.quotationCode}}</span>
        </div>
        <div>
            <ul class="quotable-items">
                <li *ngFor="let r of quotation" class="quotable-item">
                    <span class="font-bold">[{{r.code}}]</span>&nbsp;{{r.name}}
                </li>
            </ul>
        </div>
    </div>
    <div class="p-dynamic-dialog-footer">
        <div class="flex-body">
            <div class="align-right">
                <button pButton type="button" class="m-r-12" label="{{'vbeiOk' | translate}}" (click)="closeDialog()"></button>
            </div>
        </div>
    </div>
</div>